// Task #2903 — canonical "committed trip total" baseline.
//
// Three renter-facing surfaces previously derived their own
// "currently-priced-at" baseline independently and drifted apart:
//   • RequestChangeModal Original column (was reading the *pending*
//     proposal's `payment_due`, which leaked stale / withdrawn /
//     doubled values into the modal even when the Reservation panel
//     showed the correct confirmed total).
//   • RequestChangeModal Proposed delta (computed off whatever the
//     Original column happened to show, so it inherited the same
//     drift and showed phantom "−£1,380 vs original" savings).
//   • ConversationPage proposal-card "was £X" (was reading
//     `current_net_captured`, which is legitimately 0 for a
//     pre-acceptance change request — so renters saw "was £0 / +£full
//     trip due now" right after submitting an unchanged proposal).
//
// All three must now route through `getCommittedTripTotal(trip)`,
// which returns the same number the right-hand Reservation panel
// renders — `trip.payment_due`, the trip column the server bumps
// only when an adjustment is *accepted*. Pending / withdrawn /
// cancelled `trip_suggestions` rows can never influence this value.
//
// Task #2882's accept-time drift guard is intentionally NOT touched
// by this helper: that guard still uses `current_net_captured` on
// the server to refuse silent under-charges. This file is the
// *display* baseline only.
export type CommittedTotalTrip = {
  payment_due?: number | string | null;
  owner_earn?: number | string | null;
};

export function getCommittedTripTotal(trip: CommittedTotalTrip | null | undefined): number {
  if (!trip) return 0;
  const n = Number(trip.payment_due ?? 0);
  return Number.isFinite(n) ? n : 0;
}

export function getCommittedOwnerEarn(trip: CommittedTotalTrip | null | undefined): number {
  if (!trip) return 0;
  const n = Number(trip.owner_earn ?? 0);
  return Number.isFinite(n) ? n : 0;
}
